module.exports = __webpack_public_path__ + "static/img/whater-2.20320f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/whater-2.png
// module id = ag/r
// module chunks = 0